import React, { useRef } from "react";
import {
  Table,
  Input,
  TimePicker,
  InputNumber,
  Checkbox,
  Button,
  Space,
  message,
  Select,
} from "antd";
import Highlighter from "react-highlight-words";
import { SearchOutlined } from "@ant-design/icons";

class Rendertable extends React.Component {
  state = {
    searchText: "",
    searchedColumn: "",
  };

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 4, marginTop: -140 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => this.handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              this.setState({
                searchText: selectedKeys[0],
                searchedColumn: dataIndex,
              });
            }}
          >
            Filter
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select(), 100);
      }
    },
    render: (text) =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  render() {
    const employeeSalarylist = [...this.props.List];
    // const details = [...this.props.details];

    const { Option } = Select;

    // console.log("report render table");
    // console.log(employeeSalarylist);

    const columns = [
      {
        title: 'SL.',
        key: 'index',
        render: (text, record, index) => index + 1,
      },
      {
        title: "Department",
        dataIndex: "employeeDepartment",
        key: "employeeDepartment",
        // ...this.getColumnSearchProps("employeeDepartment"),
      },
      {
        title: "Pin No.",
        dataIndex: "employeeId",
        key: "employeeId",
        // ...this.getColumnSearchProps("employeeId"),
      },
      {
        title: "Name",
        dataIndex: "employeeName",
        key: "employeeName",
        // ...this.getColumnSearchProps("employeeName"),
      },
      {
        title: "Designation",
        dataIndex: "employeeRole",
        key: "employeeRole",
        // ...this.getColumnSearchProps("employeeRole"),
      },
      {
        title: "Bank account",
        dataIndex: "employeebankAccount",
        key: "employeebankAccount",
        // ...this.getColumnSearchProps("employeeRole"),
      },

      {
        title: "Basic Salary",
        dataIndex: "Basicsalary",
        align: "right",
        key: "Basicsalary",
        // ...this.getColumnSearchProps("Basicsalary"),
      },
      {
        title: "House rent",
        dataIndex: "houseRent",
        key: "houseRent",
        align: "right"
      },
      {
        title: "Medi allowance",
        dataIndex: "medAllowance",
        key: "medAllowance",
        align: "right"
      },
      {
        title: "Convenience",
        dataIndex: "convenience",
        key: "convenience",
        align: "right"
      },
      {
        title: "Food allowance",
        dataIndex: "foodAllowance",
        key: "foodAllowance",
        align: "right"
      },
      {
        title: "Gross Salary",
        dataIndex: "grossSalary",
        key: "grossSalary",
        align: "right"
      },
      {
        title: "Working days",
        dataIndex: "workingdays",
        key: "workingdays",
        align: "right"
      },
      {
        title: "Attendance Bonus",
        dataIndex: "bonus",
        key: "bonus",
        align: "right"
      },
      {
        title: "Holidays",
        dataIndex: "Holidays",
        key: "Holidays",
        align: "right"
      },

      {
        title: "Leaves",
        dataIndex: "nonpaidleave",
        key: "nonpaidleave",
        align: "right"
      },

      {
        title: "Absent",
        dataIndex: "absent",
        key: "absent",
        align: "right"
      },

      {
        title: "Absent deduction",
        dataIndex: "absentpayment",
        key: "absentpayment",
        align: "right"
      },
      {
        title: "Overtime",
        dataIndex: "totalovertime",
        key: "totalovertime",
        align: "right"
      },
      {
        title: "Overtime Payment",
        dataIndex: "overtimepayment",
        key: "overtimepayment",
        align: "right"
      },
      {
        title: "Net salary",
        dataIndex: "totalsalary",
        key: "totalsalary",
        align: "right"
      },

    ];

    return (
      <div>
        <Table columns={columns} dataSource={employeeSalarylist} size="small" pagination={false} />
      </div>
    );
  }
}

export default Rendertable;
